import { useRegistrations } from './useRegistrations';

// Zahl offener Registrierungen für die Seitenleiste (nur Admin, sonst 0). Live.
export function useOpenRegistrationsCount(): number {
  return useRegistrations().data?.open.length ?? 0;
}
